const MTR_SPEC_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  remark: '備註',
  specType: '類型',
  options: '規格選項',
};

function resolveMtrSpecFieldLabel(path) {
  const codeMatch = path.match(/^options\.(\d+)\.code$/);
  if (codeMatch) {
    return `選項 #${Number(codeMatch[1]) + 1} 代號`;
  }

  const nameMatch = path.match(/^options\.(\d+)\.name$/);
  if (nameMatch) {
    return `選項 #${Number(nameMatch[1]) + 1} 名稱`;
  }

  return undefined;
}

export {
  MTR_SPEC_FIELD_LABELS,
  resolveMtrSpecFieldLabel,
};
